module.exports = __webpack_public_path__ + "static/media/storageContainer.24357beb.svg";